import slugify from "slugify";

export const capitalizeFirstLetterOfString = (input: string) => {
    return input.charAt(0).toUpperCase() + input.slice(1);
};

export const capitalize = capitalizeFirstLetterOfString;

export const slugifyUser = (user: {
    name?: string | null | undefined;
    id?: string | null | undefined;
    slug?: string | null | undefined;
}) => {
    if (user.slug) return user.slug;

    // this replaces diatrical marks with en locale e.g "João Silva" → "joao-silva"
    const slug = slugify(user.name || "", {
        replacement: "-",
        lower: true,
        strict: true,
        locale: "en",
        trim: true,
    });

    return slug + `-${user.id?.slice(-4)}`;
};

export const toTitleCase = (input: string) => {
    return input
        .toLowerCase()
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};

export const urlSafeSlugify = (url: string) => {
    return slugify(url, {
        lower: true,
        remove: /[^a-zA-Z0-9- ]/g,
    });
};

export const truncate = (text: string, length: number) => {
    if (text.length <= length) return text;

    return [text.substring(0, length), "..."].join("");
};

export const breakLines = (text: string) => {
    return text.split("\n").join("<br/>");
};

export const truncateMid = (fullStr: string) => {
    if (fullStr.length <= 13) return fullStr;

    return [
        fullStr.substring(0, 5),
        "...",
        fullStr.substring(fullStr.length - 5),
    ].join("");
};

export const isValidEmail = (email: string | undefined | null) => {
    if (!email || email.length === 0 || email === "email") {
        return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
